import React from "react";
import { Input, InputProps } from "antd";
import { formatNumber, formatNumberFullWidthToHalfWidth } from "utils/formats";
import { isNumber } from "lodash";

interface IProps extends InputProps {
  type?: "math" | "text";
  maxLen?: number;
  onChange?: (value: any) => void;
  className?: string;
  maxDecimalDigits?: number;
  defaultValue?: string;
  min?: number;
  max?: number;
}
const NumberInputWithFormat: React.FC<IProps> = ({
  onChange,
  ...restProps
}: IProps) => {
  const { maxDecimalDigits, min, max } = restProps;
  const defaultValue = restProps.defaultValue || "";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    let numericValue = maxDecimalDigits
      ? inputValue.replace(/[^0-9０-９\.]/g, "")
      : inputValue.replace(/[^0-9０-９]/g, "");
    const match = numericValue.match(/^([^。\.]*[。\.]?[^。\.]*)/);
    const arrayByDot = numericValue.split(".");
    if (match && maxDecimalDigits) {
      numericValue = match ? match[0] : "";
      const decimal = arrayByDot[1];
      if (decimal) {
        if (decimal.length > maxDecimalDigits) return;
      }
    }
    if (restProps.type === "math") {
      const isIncludeZero = numericValue.includes("0");
      numericValue = numericValue.replace(/^0+(?=\d)/, "") || defaultValue;
      if (!numericValue && isIncludeZero) numericValue = "0";
    }
    numericValue = formatNumberFullWidthToHalfWidth(numericValue)
    if (restProps?.maxLen && arrayByDot[0].length > restProps.maxLen) return;
    if (inputValue && isNumber(min) && Number(numericValue) < min) return;
    if (inputValue && max && Number(numericValue) > max) return;
    if(!arrayByDot[0] && numericValue?.includes(".")) numericValue =  "0" + numericValue

    onChange &&
      onChange(
        formatNumber(
          formatNumberFullWidthToHalfWidth(
            (numericValue as string) || defaultValue
          )
        )
      );
  };

  const handleBlur = () => {
    onChange?.(
      formatNumber(
        formatNumberFullWidthToHalfWidth(
          (restProps?.value as string) || defaultValue
        )
      )
    );
  };

  return (
    <Input
      inputMode="numeric"
      {...restProps}
      onChange={handleChange}
      onBlur={handleBlur}
      className={restProps.className ? restProps.className : ""}
    />
  );
};

export default NumberInputWithFormat;
